import { ReactNode, useCallback } from 'react'
import { BadgeWrapper } from '$common/badge/styled-badge'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { AvatarBase, AvatarBaseProps } from '$common/avatar/avatar-base'

export interface SelectableAvatarProps extends AvatarBaseProps {
  avatarBackgroundText: ReactNode
  checked?: boolean
  online?: boolean
  backdrop?: ReactNode
  handleOnboarding?: () => unknown
}

export function SelectableAvatar({
  avatarBackgroundText,
  checked = false,
  online = false,
  hasDeleted,
  ongoingCallType,
  backdrop,
  handleOnboarding,
  onClick,
  ...rest
}: SelectableAvatarProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (handleOnboarding) {
        handleOnboarding()
        return
      }
      if (onClick) {
        onClick(e)
      }
    },
    [handleOnboarding, onClick],
  )
  return (
    <BadgeWrapper
      selected={checked}
      online={online}
      ongoingCallType={ongoingCallType}
      hasOnboarding={!!handleOnboarding}
    >
      <>
        <AvatarBase
          hasDeleted={hasDeleted}
          ongoingCallType={ongoingCallType}
          onClick={handleClick}
          {...rest}
        >
          {hasDeleted ? <RemovePersonIcon /> : avatarBackgroundText}
        </AvatarBase>
        {backdrop}
      </>
    </BadgeWrapper>
  )
}
